import styled, { css } from 'styled-components';
import applyResponsiveVdpStyles from '../../../../_shared/helpers/applyResponsiveVdpStyles';

/**
 * Variant Definitions
 */
const StyledHeaderVariants = {
  mini: css`
    display: none;
  `,
  expanded: css`
    display: flex;
    flex-direction: row;
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
    border-bottom: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
    align-items: center;
    justify-content: space-between;
    padding: 24px 18px 18px;
  `
};

/**
 * Styled Components
 */
export const StyledHeader = styled.div`
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledHeaderVariants.mini,
      expanded: StyledHeaderVariants.expanded
    })}
`;

export const StyledState = styled.div`
  font-size: 24px;
  line-height: 1;
`;

export const StyledActiveTimerContainer = styled.div`
  margin-left: ${({ isAuctionEnded }) => !isAuctionEnded && '40px'};
  display: flex;
`;
